module.exports = __webpack_public_path__ + "img/reviewBoulPic.24360d38.jpeg";